import useHttp from './use-http';

const useBrands = () => {
    const getSocialAccounts = (brandId) => {
        const url = `/api/v1/brand/${brandId}/social-accounts`;

        const { http } = useHttp();
        return http.get(url);
    };

    return {
        getSocialAccounts
    };
};

export default useBrands;
